import { IconButton } from '@mui/material'
import React from 'react'

import { Icon } from '#/components/Icon'

export const Refresh = ({ mutate }) => (
  <IconButton
    sx={{
      padding: '6px',
      marginLeft: 'auto',
    }}
    onClick={() => mutate()}
  >
    <Icon size="large" name="mdi-refresh" />
  </IconButton>
)
